import React, { useEffect, useState } from "react"
import { ADMIN_PERMISSIONS } from "../../../../constants"
import { adminNavElements } from "./adminNavElements"
import AdminNavListElement from "./AdminNavListElement"
export interface adminNavElement {
  name: string
  href: string
  permittedPermissions: string[]
  attributeToCheck?: string
  permissionToCheck?: string
  borderBottom?: boolean
  icon: (color?: string) => React.JSX.Element
}

const AdminNavSection = ({ user, missingShareHolderCount, releaseEditAgainSubmitCount, userHasUpdateCount }: any) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0)
  const [userAdminPermissionList, setUserAdminPermissionList] = useState<string[]>([])

  useEffect(() => {
    setUserAdminPermissionList(user.adminPermissions?.split(",") || [])
  }, [user])

  const renderFlagCount = (name: string) => {
    if (name === "Actions") {
      return missingShareHolderCount
    } else if (name === "Asset Registry (Releases)") {
      return releaseEditAgainSubmitCount
    } else if (name === "User Asset") {
      return userHasUpdateCount
    }
    return 0
  }

  return (
    <div className="flex flex-col grow justify-start ">
      {adminNavElements.map((nav: adminNavElement, index: number) => {
        const isAuthorized =
          !nav.permittedPermissions.length ||
          nav.permittedPermissions.some((permission) => userAdminPermissionList.includes(permission))

        return isAuthorized ? (
          <div
            key={`navlist-element-${index}`}
            style={{
              marginTop: nav.name === "Registrations" ? "auto" : "0px"
            }}
          >
            <AdminNavListElement
              index={index}
              name={nav.name}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              href={nav.href}
              Icon={nav.icon}
              flagCount={renderFlagCount(nav.name)}
            />
          </div>
        ) : null
      })}
    </div>
  )
}

export default AdminNavSection
